import Box from '@/components/UI/box/Box'
import styles from './GetInformation.module.scss'
import Alert from '@/components/UI/alert/Alert'
import InformationForm from './informationForm/InformationForm'

const GetInformation = () => {
  return (
    <Box className={`${styles['get-information']} ${styles['slide-in-right']}`}>
      <Alert
        title={
          'شماره موبایل با موفقیت تایید شد. لطفا برای نهایی‌سازی ثبت‌نام اطلاعات تکمیلی را وارد کنید.'
        }
        type="secondary"
        icon="info-circle"
        className={styles['alert']}
      />
      <InformationForm />
    </Box>
  )
}

export default GetInformation
